var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.99 90.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff451b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 5,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 45,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64.99,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 5,
    cy: 25.02,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25,
    cy: 25.02,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 45,
    cy: 25.02,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64.99,
    cy: 25.02,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 5,
    cy: 45.02,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25,
    cy: 45.02,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 45,
    cy: 45.02,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64.99,
    cy: 45.02,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 5,
    cy: 65.04,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25,
    cy: 65.04,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 45,
    cy: 65.04,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64.99,
    cy: 65.04,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 5,
    cy: 85.04,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25,
    cy: 85.04,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 45,
    cy: 85.04,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64.99,
    cy: 85.04,
    r: 5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.c2ad6bc4e15101a8adbc70424fdde2fd.svg";
export { ForwardRef as ReactComponent };